import React from 'react';

import { CardList } from './InvoiceCardList.styled';
import Invoice from 'screens/Invoices/types/invoice';

import { InvoiceCardListItem } from './InvoiceCardListItem';

export const InvoiceCardList = ({
  hasUnappliedPaymentsTotalCents,
  invoices,
  onPayInvoice,
  onViewInvoice
}: {
  hasUnappliedPaymentsTotalCents: boolean;
  invoices: Invoice[];
  onPayInvoice: (invoice: Invoice) => void;
  onViewInvoice: (invoice: Invoice) => void;
}) => {
  return (
    <CardList>
      {invoices.map(invoice => (
        <InvoiceCardListItem
          key={invoice.id}
          hasUnappliedPaymentsTotalCents={hasUnappliedPaymentsTotalCents}
          invoice={invoice}
          onPayClick={() => onPayInvoice(invoice)}
          onViewInvoice={() => onViewInvoice(invoice)}
        />
      ))}
    </CardList>
  );
};
